import parser from "./parser";
import { marked } from "marked";
import mkp from "./make_parse_function";

const parse = mkp.makeParseFunction(parser, marked);
export default parse;
